import classNames from "classnames";

import GroupIcon from "../../../../../Components/Icon-SVG/GroupIcon";

const AgentGroupItem = ({ agentGroup, showIcon = false, onCheck = () => {}, checked = false }) => {
  const { id, name, type } = agentGroup;

  return (
    <div
      className={classNames("agent-group-item", {
        "agent-group-item--checked": checked,
      })}>
      <input
        type="checkbox"
        value={id}
        name="agentGroupItem"
        className="submit-popup-container__vm--input"
        onChange={onCheck}
        checked={checked}
      />
      {showIcon ? <GroupIcon width={14} height={14} /> : null}
      <span className="name" title={name}>
        {name}
      </span>
      <span className={`type --${type}`}>{type}</span>
    </div>
  );
};

export default AgentGroupItem;
